import { HttpNetworkError, type Router } from '@inertiajs/core';
import type { Emitter } from '@/types/emitter';

export function ignoreBackgroundNetworkError(error: Error) {
    if (error instanceof HttpNetworkError) {
        // Let the next scheduled refresh try again.
        return false;
    }
}

export function registerInertiaNetworkErrorListener(router: Router, emitter: Emitter) {
    return router.on('networkError', (event) => {
        // Inertia also routes unexpected application errors through this event.
        if (!(event.detail.error instanceof HttpNetworkError)) {
            return;
        }

        event.preventDefault();
        emitter.emit('flash-message', {
            type: 'error',
            text: 'Connection lost. We could not confirm whether your request completed. Check your connection and refresh before trying again.',
        });
    });
}
